"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidGroupChildError = function (_Error) {
  _inherits(InvalidGroupChildError, _Error);

  function InvalidGroupChildError() {
    var _ref;

    _classCallCheck(this, InvalidGroupChildError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = InvalidGroupChildError.__proto__ || Object.getPrototypeOf(InvalidGroupChildError)).call.apply(_ref, [this].concat(args)));

    Error.captureStackTrace(_this, InvalidGroupChildError);
    return _this;
  }

  return InvalidGroupChildError;
}(Error);

exports.default = InvalidGroupChildError;